export enum QuizAnswer {
    livingPreferenceAnswer = 1,
    atHomeAnswer = 2,
    broadbandUsagePreference = 3
}